import React from "react";
import { Input, Button } from "antd";
import { Icon } from "../components";
import strings from "./strings";

function getNestedValue(obj: any, path: string): any {
	if (!obj || !path) return undefined;

	// Normalize path: remove optional chaining, convert brackets to dots
	const normalizedPath = path
		.replace(/\?\./g, ".") // remove optional chaining dots
		.replace(/\?\[(\d+)\]/g, "[$1]") // remove optional chaining with brackets
		.replace(/\[(\d+)\]/g, ".$1"); // convert [0] to .0

	// Split into parts
	const parts = normalizedPath.split(".").filter(Boolean);

	// Walk through the object safely
	let current = obj;
	for (const key of parts) {
		if (current == null) return undefined;
		current = current[key];
	}

	return current;
}

// This is mainly for field filter search (normally by string fields)
export function getColumnFilter(dataIndex: string | string[]) {
	return {
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
			<div style={{ padding: 8 }}>
				<Input
					value={selectedKeys[0]}
					placeholder={strings.generic.search}
					onChange={(e) => {
						setSelectedKeys(e.target.value ? [e.target.value] : []);
					}}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							confirm({ closeDropdown: true });
						}
					}}
					style={{ width: 188, marginBottom: 8, display: "block" }}
				/>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<Button className="ColumnButton" onClick={() => confirm({ closeDropdown: true })}>
						{strings.generic.search}
					</Button>
					<Button
						className="ColumnButton"
						onClick={() => {
							setSelectedKeys([]);
							clearFilters && clearFilters({ closeDropdown: true });
						}}
					>
						{strings.generic.reset}
					</Button>
				</div>
			</div>
		),
		filterIcon: (filtered: boolean) => <Icon name="search" style={{ color: filtered ? "#1890ff" : undefined }} />,
		onFilter: (value: string | number | boolean, record: any) => {
			const paths = Array.isArray(dataIndex) ? dataIndex : [dataIndex];
			const searchValue = value?.toString().toLowerCase().trim() ?? "";

			return paths.some((path) => {
				const recordValue = getNestedValue(record, path);
				if (recordValue == null) return false;

				const recordString = recordValue.toString().toLowerCase().trim();

				return recordString.includes(searchValue);
			});
		}
	};
}
